import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSystemNotificationsMutationVariables = Types.Exact<{
  targetUsers: Types.Scalars['String']['input'];
  notificationMessage: Types.Scalars['String']['input'];
  deepLink?: Types.InputMaybe<Types.Scalars['String']['input']>;
  payload?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateSystemNotificationsMutation = { __typename?: 'mutation_root', newSystemNotifications?: { __typename?: 'newSystemNotifications', successCount: number, failuresCount: number } | null };


export const CreateSystemNotificationsDocument = gql`
    mutation createSystemNotifications($targetUsers: String!, $notificationMessage: String!, $deepLink: String, $payload: String) {
  newSystemNotifications(
    targetUsers: $targetUsers
    notificationMessage: $notificationMessage
    deepLink: $deepLink
    payload: $payload
  ) {
    successCount
    failuresCount
  }
}
    `;
export type CreateSystemNotificationsMutationFn = Apollo.MutationFunction<CreateSystemNotificationsMutation, CreateSystemNotificationsMutationVariables>;

/**
 * __useCreateSystemNotificationsMutation__
 *
 * To run a mutation, you first call `useCreateSystemNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSystemNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSystemNotificationsMutation, { data, loading, error }] = useCreateSystemNotificationsMutation({
 *   variables: {
 *      targetUsers: // value for 'targetUsers'
 *      notificationMessage: // value for 'notificationMessage'
 *      deepLink: // value for 'deepLink'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateSystemNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSystemNotificationsMutation, CreateSystemNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSystemNotificationsMutation, CreateSystemNotificationsMutationVariables>(CreateSystemNotificationsDocument, options);
      }
export type CreateSystemNotificationsMutationHookResult = ReturnType<typeof useCreateSystemNotificationsMutation>;
export type CreateSystemNotificationsMutationResult = Apollo.MutationResult<CreateSystemNotificationsMutation>;
export type CreateSystemNotificationsMutationOptions = Apollo.BaseMutationOptions<CreateSystemNotificationsMutation, CreateSystemNotificationsMutationVariables>;